import React, { useEffect } from "react";
import { Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../LabsStockManagement/redux/actions";
import DashboardVarianceReportTable from "./DashboardVarianceReportTable";

const DashboardExpandedRow = ({ record }) => {
  const dispatch = useDispatch();

  const registerId = record?.id;

  const varianceReports = useSelector((state) => state.labsStockManagementReducer.varianceReports);

  const hasVarianceReports =
    (record.varianceReports && record.varianceReports.length > 0) ||
    (record.variance_reports && record.variance_reports.length > 0) ||
    (Array.isArray(varianceReports[registerId]) && varianceReports[registerId].length > 0);

  const hasAttemptedFetch = Object.prototype.hasOwnProperty.call(varianceReports, registerId);

  useEffect(() => {
    if (registerId && !hasAttemptedFetch && !hasVarianceReports) {
      dispatch(actions.fetchAllVarianceReports(registerId));
    }
  }, [registerId, dispatch, hasAttemptedFetch, hasVarianceReports]);

  const isVarianceGenerated =
    hasVarianceReports ||
    (record.varianceReports && record.varianceReports.length > 0) ||
    (record.variance_reports && record.variance_reports.length > 0);

  return (
    <div style={{ padding: "20px 0px" }}>
      <Row gutter={[16, 16]} className="stock-expanded-row-container">
        {isVarianceGenerated && (
          <Col span={24} key="variance-report-col">
            <DashboardVarianceReportTable registerId={registerId} record={record} />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default DashboardExpandedRow;
